import { Anchor, Button, Group, Paper, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link, Route, Routes, useParams } from 'react-router';
import { IME_APLIKACIJE } from '../ime';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { clanek } from './clanki';
import { ClanekVsebina } from './ClanekVsebina';
import { SeznamNavodil } from './Pomoc';

/**
 * Navodila brez prijave ({@code /navodila}, {@code /navodila/:clanek}): isti članki kot Pomoč v aplikaciji, za
 * povezave v mailih, novicah in na spletni strani.
 */
export function JavnaNavodila() {
  return (
    <TemnoOzadje sirina={900}>
      <Paper radius="lg" p={{ base: 20, sm: 40 }} shadow="xl">
        <Routes>
          <Route path="navodila" element={<SeznamJavno />} />
          <Route path="navodila/:clanek" element={<ClanekJavno />} />
        </Routes>
        <Group justify="center" mt="xl">
          <Anchor component={Link} to="/" size="sm">
            Prijava v {IME_APLIKACIJE}
          </Anchor>
        </Group>
      </Paper>
    </TemnoOzadje>
  );
}

function SeznamJavno() {
  return (
    <>
      <Title order={1} size="h2" mb="md">
        Navodila za {IME_APLIKACIJE}
      </Title>
      <SeznamNavodil osnova="/navodila" />
    </>
  );
}

function ClanekJavno() {
  const c = clanek(useParams().clanek);
  return (
    <>
      <Button component={Link} to="/navodila" variant="subtle" leftSection={<IconArrowLeft size={16} />} px={0} mb="sm">
        Vsa navodila
      </Button>
      {c ? <ClanekVsebina clanek={c} osnova="/navodila" /> : <Text>Navodila ne obstajajo (več).</Text>}
    </>
  );
}
